import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Node } from '@xanadu/model';

@Component({
    selector: 'app-access',
    templateUrl: './access.component.html',
    styleUrls: ['./access.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccessComponent {
    formGroup = input<FormGroup>();
    node = input<Node>();
    admission = input<string[]>();
    readonly = input<boolean>();

    metaName: any = { id: 'name', name: 'Access' };
    metaClients: any = { id: 'clients', name: 'Clients', info: 'Clients assigned' };
    keys: string[] = [];
}
